import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

import { FilterProvider } from './contexts/FilterContext';
import { QueryProvider } from './contexts/QueryContext';

import '@nb/css-reset/src/style.css';
import '@nb/fonts/src/style.css';
import '@nb/style-props/build-style/color-schemes/nb.css';
import '@nb/style-props/build-style/style.css';

window.addEventListener('DOMContentLoaded', () => {
	const target = document.getElementById('root');
	if (target) {
		ReactDOM.render(
			<React.StrictMode>
				<Router>
					<FilterProvider>
						<QueryProvider>
							<App />
						</QueryProvider>
					</FilterProvider>
				</Router>
			</React.StrictMode>,
			target,
		);
	}
});
